import { PlatformFeatureType } from '@conversed/shared/src/central/types/platform-features.type';

export type TCompanyFeatureToggle = {
  feature: PlatformFeatureType;
  id: string;
  titleKey: string;
  descriptionKey?: string;
  // When this feature is active the toggle is disabled (mutually exclusive pair)
  disabledByFeature?: PlatformFeatureType;
  disabledReasonKey?: string;
  // Only rendered for Email AI studios
  emailStudioOnly?: boolean;
};

export const COMPANY_FEATURE_TOGGLES: TCompanyFeatureToggle[] = [
  {
    feature: PlatformFeatureType.MicrosoftSSO,
    id: 'microsoftSSOToggle',
    titleKey: 'general-settings.microsoft-sso.title',
  },
  {
    feature: PlatformFeatureType.LLMBlockFilteringForTrainAI,
    id: 'llmBlockFilteringToggle',
    titleKey: 'general-settings.llm-block-filtering.title',
    descriptionKey: 'general-settings.llm-block-filtering.description',
    disabledByFeature: PlatformFeatureType.HotTopicFilterForTrainAI,
    disabledReasonKey: 'general-settings.llm-block-filtering.disabled-reason',
  },
  {
    feature: PlatformFeatureType.HotTopicFilterForTrainAI,
    id: 'hotTopicFilterToggle',
    titleKey: 'general-settings.hot-topic-filter.title',
    descriptionKey: 'general-settings.hot-topic-filter.description',
    disabledByFeature: PlatformFeatureType.LLMBlockFilteringForTrainAI,
    disabledReasonKey: 'general-settings.hot-topic-filter.disabled-reason',
  },
  {
    feature: PlatformFeatureType.AutomaticRetraining,
    id: 'automaticRetrainingToggle',
    titleKey: 'general-settings.automatic-retraining.title',
    descriptionKey: 'general-settings.automatic-retraining.description',
  },
  {
    feature: PlatformFeatureType.UseAIKnowledgeLabels,
    id: 'useAIKnowledgeLabelsToggle',
    titleKey: 'general-settings.use-ai-knowledge-labels.title',
    descriptionKey: 'general-settings.use-ai-knowledge-labels.description',
  },
  {
    feature: PlatformFeatureType.AIKnowledgeHubV2,
    id: 'useAIKnowledgeHubV2Toggle',
    titleKey: 'general-settings.use-ai-knowledge-hub-v2.title',
  },
  {
    feature: PlatformFeatureType.ConversationKeywords,
    id: 'conversationKeywordsToggle',
    titleKey: 'platform-features.conversation-keywords.label',
    descriptionKey: 'platform-features.conversation-keywords.description',
  },
  {
    feature: PlatformFeatureType.WebclientVoice,
    id: 'webclientVoiceToggle',
    titleKey: 'platform-features.webclient-voice.label',
    descriptionKey: 'platform-features.webclient-voice.description',
  },
  {
    feature: PlatformFeatureType.MultilingualTrainAI,
    id: 'multilingualTrainAIToggle',
    titleKey: 'platform-features.multilingual-train-ai.label',
    descriptionKey: 'platform-features.multilingual-train-ai.description',
  },
  {
    feature: PlatformFeatureType.EmailAIStudio,
    id: 'emailAIStudioToggle',
    titleKey: 'platform-features.email-ai-studio.label',
    descriptionKey: 'platform-features.email-ai-studio.description',
    emailStudioOnly: true,
  },
  {
    feature: PlatformFeatureType.TrainAIV2,
    id: 'trainAIV2Toggle',
    titleKey: 'general-settings.train-ai-v2.title',
    descriptionKey: 'general-settings.train-ai-v2.description',
  },
  {
    feature: PlatformFeatureType.ContactLookup,
    id: 'contactLookupToggle',
    titleKey: 'general-settings.contact-lookup.title',
    descriptionKey: 'general-settings.contact-lookup.description',
  },
];
